import React from 'react';
import AnnouncementPopup from '../AnnouncementPopup/AnnouncementPopup';
import FlemishHeader from '../FlemishHeader/FlemishHeader';
import MainNavigation from '../MainNavigation/MainNavigation';
import MainFooter from '../MainFooter/MainFooter';
import FlemishFooter from '../FlemishFooter/FlemishFooter';

type LayoutProps = {
  children: React.ReactNode;
};

export default function Layout({ children }: LayoutProps): React.JSX.Element {
  return (
    <>
      <FlemishHeader />
      <MainNavigation />
      {/*<AnnouncementPopup
        title="Ben je uitgenodigd om de vragenlijst Gemeente-Stadsmonitor in te vullen?"
        content={
          <>
            <p>
              Ga naar de link die je vindt op de uitnodigingsbrief (
              <a
                href="https://www.gemeentemonitor.be"
                target="_blank"
                rel="noreferrer"
                className="vl-link vl-link--bold"
              >
                www.gemeentemonitor.be
              </a>{' '}
              of{' '}
			  <a
                href="https://www.stadsmonitor.be"
                target="_blank"
                rel="noreferrer"
                className="vl-link vl-link--bold"
              >
                www.stadsmonitor.be
              </a>
				) en vul je persoonlijke code in.
            </p>
          </>
        }
      />*/}
      <main>
        {children}

        <div className="loader-overlay hidden">
          <div className="vl-loader"/>
        </div>
      </main>
      <MainFooter />
      <FlemishFooter />
    </>
  );
}
